<template>
  <div class="lc-user-card">
    <div class="lc-user-card__wrapper">
      <div class="lc-user-card__content">
        <div class="lc-user-card__img-container">
          <img
            :src="img"
            class="lc-user-card__img"
            v-if="img && !imgError"
            @error="imgError = true"
          />
          <div class="lc-user-card__cont-img" v-else>
            <img
              class="lc-user-card__inner-img"
              src="@/assets/chatbotspl_logo_blue.png"
            />
          </div>
        </div>
        <div ref="textCont" class="lc-user-card__text-container">
          <div class="lc-user-card__name">{{ name }}</div>
          <slot name="addInfo"></slot>
          <!-- <div ref="refMsg" class="lc-user-card__msg">
            {{ delayedMsg }}
          </div>-->
        </div>
        <div class="lc-user-card__status-container">
          <div
            class="lc-user-card__status"
            :class="[newMsg ? 'lc-user-card__status-notif' : '']"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      delayedMsg: "",
      imgError: false,
    };
  },

  props: {
    name: String,
    img: String,
    msg: String,
    newMsg: Boolean,
  },

  watch: {
    msg: function () {
      //this.updateMsgWidth()
    },
  },

  mounted() {
    //this.updateMsgWidth()
  },

  methods: {
    updateMsgWidth() {
      setTimeout(() => {
        this.$refs.refMsg.style.width = this.$refs.textCont.clientWidth + "px";
        this.delayedMsg = this.msg;
      }, 0);
    },
  },
};
</script>

<style lang="scss">
.lc-user-card {
  &__content {
    background: white;
    border-radius: 6px;
    padding: 8px;

    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  &__img-container {
    display: flex;
    margin-right: 10px;
  }

  &__img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    object-fit: cover;
  }

  &__cont-img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__inner-img {
    margin-top: 3px;
    width: 55%;
    height: 55%;
  }

  &__text-container {
    margin-right: 6px;
  }

  &__name {
    font-size: 1.1em;
  }

  &__msg {
    font-size: 0.95em;
    color: $inactiveGrey;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__status-container {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  &__status {
    border-radius: 50%;
    width: 10px;
    height: 10px;
    background-color: inherit;
    margin-left: 4px;
  }

  &__status-notif {
    background-color: $primary;
  }
}
</style>
